export default "/assets/images/awards-img-02-sm.adddcd35ae939e4a.svg";